<web-settings-body>
    <web-settings-breadcrumbs>
        <div class="breadcrumb-icon">
            @if (!activeThemeSetting()) {
                <img
                    src="./assets/img/websites/lpc-theme-settings-icon.svg"
                    class="first-breadcrumb-icon"
                    alt="lpc-theme-settings-icon"
                />
            } @else {
                <a (click)="unselectActiveTheme()">
                    <img
                        src="./assets/img/websites/lpc-back-icon.svg"
                        class="first-breadcrumb-icon"
                        alt="lpc-back-icon"
                    />
                </a>
            }
            <!--                <img *ngIf="activeThemeSetting" src="assets/img/websites/lpc-breadcrumb-arrow-icon.svg" class="breadcrumb-arrow-icon">-->
        </div>
        <div class="breadcrumb-text">
            @if (!activeThemeSetting()) {
                <span>{{ "site_styles" | translate }}</span>
            } @else {
                <span>{{ activeThemeLabel[activeThemeSetting()] | translate }}</span>
            }
        </div>
    </web-settings-breadcrumbs>
    <a [href]="'knowledge_base_theme_link' | translate" class="kb-link" target="_blank">
        <span class="small sp-icon icon-info"> </span> {{ "knowledge_base_theme_tooltip" | translate }}
        <span class="color-light small sp-icon icon-outgoing"> </span>
    </a>

    <div class="theme-setting-notification">
        <div class="alert alert-info-mutted alert-sm mb-10">
            {{ "theme_settings_notification" | translate }}
        </div>
    </div>

    <sp-themes [deviceMode]="deviceMode$ | async" (changeDeviceMode)="changeDeviceMode($event)" />
</web-settings-body>
